import { render, staticRenderFns } from "./NotificationsPage.vue?vue&type=template&id=23eb6676&scoped=true&"
import script from "./NotificationsPage.vue?vue&type=script&lang=ts&"
export * from "./NotificationsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eb6676",
  null
  
)

export default component.exports